import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";

// Ekrandaki metinler seçilen sağlayıcıya göre değişir — eskiden hep "PayTR"
// yazıyordu, iyzico seçildiğinde de yanlışlıkla PayTR marka adı görünüyordu.
// Türkçe hal ekleri ("-nin"/"-nun", "-ye"/"-ya") isme göre değiştiğinden tek
// bir ad yerine, her sağlayıcı için hazır çekimli biçimler tutuluyor.
const PROVIDER_LABELS = {
  paytr:  { name: "PayTR",  possessive: "PayTR'nin",  dative: "PayTR'ye" },
  iyzico: { name: "iyzico", possessive: "iyzico'nun",  dative: "iyzico'ya" },
};
const FALLBACK_LABELS = { name: "Ödeme sağlayıcımız", possessive: "ödeme sağlayıcımızın", dative: "ödeme sağlayıcımıza" };

export default function CartPaymentStep() {
  const location = useLocation();
  const navigate = useNavigate();
  const { iframeUrl, orderId, orderNumber, provider } = location.state || {};
  const labels = PROVIDER_LABELS[provider] || FALLBACK_LABELS;

  useEffect(() => {
    if (!iframeUrl) navigate("/sepet", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [iframeUrl]);

  if (!iframeUrl) return null;

  return (
    <div className="max-w-2xl mx-auto space-y-4">
      <div>
        <h1 className="font-serif text-3xl mb-1">Güvenli Ödeme</h1>
        <p className="text-sm text-[#888888]">
          Sipariş #{orderNumber ?? orderId} için kart bilgilerinizi {labels.possessive} güvenli ekranına giriyorsunuz.
        </p>
      </div>

      <div className="flex items-center gap-2 text-xs text-[#888888]">
        <ShieldCheck className="w-4 h-4 text-[#A85C34]" />
        Kart bilgileriniz sitemizden geçmez, doğrudan {labels.dative} iletilir.
      </div>

      <div className="rounded-2xl border border-[#EAEAEA] overflow-hidden" style={{ minHeight: 640 }}>
        <iframe
          src={iframeUrl}
          title={`${labels.name} Güvenli Ödeme`}
          id="paytriframe"
          frameBorder="0"
          width="100%"
          style={{ minHeight: 640, border: "none" }}
          data-testid="paytr-iframe"
        />
      </div>
    </div>
  );
}
